import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    //create user
    create_user:{},
    create_more_user_info:{},
    questions:{},
    submitAnswer:{},
    validateCard:{},
    setCardDetail:{},
    completeEnrollmentData:{},
    autoScLoginRes:{},
    verifyAnswer: {},
    generateResultResponse: null,
};

export const createUser = createAsyncThunk('idiq-api/createUser', async (initialPost) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    formData.append("first_name",initialPost.first_name);
    formData.append("last_name",initialPost.last_name);
    // formData.append("email",initialPost.email);
    formData.append("dob",initialPost.dob);
    formData.append("street",initialPost.street);
    formData.append("city",initialPost.city);
    formData.append("state",initialPost.state);
    formData.append("zip",initialPost.zip);
    
    formData.append("ssn",initialPost.ssn);
    let response = await axios.post('form/Enroll_Member',formData);
    if (response.status === 200) {
        // if(response.data.errors){
            return response.data;
        // }else{
        //     return { error:0 }
        // }
    }else{
        throw new Error(response.statusText)
    }
});

export const updateProviderLogin = createAsyncThunk('idiq-api/updateProviderLogin', async (initialPost) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);

    formData.append("username",initialPost.username);
    formData.append("password",initialPost.password);
    initialPost.ssn && formData.append("last4ofsocial",initialPost.ssn);

    let response = await axios.post('form/updateUserProviderInfo',formData);
    if (response.status === 200) {
        if(response.data.error === 0){
            return response.data;
        }else{
            throw new Error(response.data.msg)
        }
    }else{
        throw new Error(response.statusText)
    }
});

export const importIDIQReport = createAsyncThunk('idiq-api/importIDIQReport', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    formData.append("env",document.body.dataset['app_base_url'].includes("app") ? "member" : "gcpstage");
    // formData.append("email",email);
    let response = await axios.post('form/importIDIQReportByPuppyteer',formData);
    if (response.status === 200) {
        if(response.data.error === 0){
            return response.data;
        }else{
            throw new Error(response.data.msg)
        }
    }else{
        throw new Error(response.statusText)
    }
});

export const autoCompleteAppFlow = createAsyncThunk('idiq-api/autoCompleteAppFlow', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('form/autoCompleteReportAudit',formData);
    if (response.status === 200) {
        if(response.data.error === 0){
            return response.data;
        }else{
            throw new Error(response.data.msg)
        }
    }else{
        throw new Error(response.statusText)
    }
});

export const generateResult = createAsyncThunk('idiq-api/generateResult', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    formData.append("env",document.body.dataset['app_base_url'].includes("app") ? "member" : "gcpstage");
    let response = await axios.post('form/generateResultAtCurrentRoundEnd',formData);
    if (response.status === 200) {
        return response.data;
    }else{
        throw new Error(response.statusText)
    }
});

export const fetchPrintJobs = createAsyncThunk('idiq-api/fetchPrintJobs', async (page) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    formData.append("page", page);
    let response = await axios.post('form/getDisputeLettersPrintJobs',formData);
    if (response.status === 200) {
        if(response.data.error === 0){
            return response.data;
        }else{
            throw new Error(response.data.msg)
        }
    }else{
        throw new Error(response.statusText)
    }
});

export const markGHLContactDisputely = createAsyncThunk('idiq-api/markGHLContactDisputely', async (email) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('form/markGHLContactDisputely',formData);

    return response.data;

    // if (response.status === 200) {
    //     if(response.data.error === 0){
    //         return response.data;
    //     }else{
    //         throw new Error(response.data.msg)
    //     }
    // }else{
    //     throw new Error(response.statusText)
    // }
});


export const verifyAnswers = createAsyncThunk('idiq-api/verifyAnswers', async data => {
  let accessToken = localStorage.getItem('accessToken');
  let formData = new FormData();
  formData.append('Token', accessToken);
//   formData.append('email', data.email);

  if (data.selectedAnswerIds && Array.isArray(data.selectedAnswerIds)) {
    data.selectedAnswerIds.forEach((answerId, index) => {
      formData.append(`answers[${index}]`, answerId);
    });
  } else {
    throw new Error('selectedAnswerIds is not an array or is not provided');
  }

  let response = await axios.post('form/Verify_Answers', formData);
  if (response.status === 200) {
    return response.data;
  } else {
    throw new Error(response.statusText);
  }
});






export const createMoreUserInfo = createAsyncThunk('idiq-api/createMoreUserInfo', async (initialPost) => {
    let formData = new FormData();
    let customerToken = localStorage.getItem('customerToken');
    formData.append("customer_token",customerToken);
    formData.append("phone",initialPost.phone);
    formData.append("street",initialPost.street);
    formData.append("zip",initialPost.zip);
    formData.append("city",initialPost.city);
    formData.append("state",initialPost.state);
    formData.append("dob",initialPost.dob);
    formData.append("ssn",initialPost.ssn);
    let response1 = await axios.post('demo/set_identity_partial_ssn',formData);
    let response = await axios.post('demo/set_identity_ssn',formData);
    if (response.status === 200) {
        //console.log("response=>",response);
        if(response.data.errors){
            return response.data;
        }else{
            return { error:0 }
        }
    }else{
        throw new Error(response.statusText)
    }
})

export const fetchQuestions = createAsyncThunk('idiq-api/fetchQuestions', async (initialPost) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    // formData.append("email",initialPost.email);
    let response = await axios.post('form/Get_Verification_Questions',formData);
    if (response.status === 200) {
        return response.data;
    }else{
        throw new Error(response.statusText)
    }

})

export const submitQuestionAnswer = createAsyncThunk('idiq-api/submitQuestionAnswer', async (initialPost) => {
    let customerToken = localStorage.getItem('customerToken');
    let formData = new FormData();
    formData.append("customer_token",customerToken);
    formData.append("ref_number",initialPost.ref_number);
    formData.append("q1",initialPost.q1);
    formData.append("q2",initialPost.q2);
    formData.append("q3",initialPost.q3);
    let response = await axios.post('demo/put_answers',formData);
    if (response.status === 200) {
        return response.data;
    }else{
        throw new Error(response.statusText)
    }
})

export const validateCreditCard = createAsyncThunk('idiq-api/validateCreditCard', async (initialPost) => {
    let formData = new FormData();
    formData.append("cc_number",initialPost.cc_number);
    let response = await axios.post('demo/validate_credit_card',formData);
    if (response.status === 200) {
        return response.data;
    }else{
        throw new Error(response.statusText)
    }
})

export const creditCardDetail = createAsyncThunk('idiq-api/creditCardDetail', async (initialPost) => {
    let customerToken = localStorage.getItem('customerToken');
    let formData = new FormData();
    formData.append("customer_token",customerToken);
    formData.append("card_token",initialPost.card_token);
    formData.append("name",initialPost.name);
    formData.append("cvv",initialPost.cvv);
    formData.append("month",initialPost.month);
    formData.append("year",initialPost.year);
    let response = await axios.post('demo/set_credit_card',formData);
    if (response.status === 200) {
        return response.data;
    }else{
        throw new Error(response.statusText)
    }
})

export const completeEnrollment = createAsyncThunk('idiq-api/completeEnrollment', async (initialPost) => {
    let customerToken = localStorage.getItem('customerToken');
    let formData = new FormData();
    formData.append("customer_token",customerToken);
    let response = await axios.post('demo/complete_enrollment',formData);
    if (response.status === 200) {
        return response.data;
    }else{
        throw new Error(response.statusText)
    }
})

export const autoScLogin = createAsyncThunk('idiq-api/autoScLogin', async (initialPost) => {
    let formData = new FormData();
    formData.append("username",initialPost.username);
    formData.append("password",initialPost.password);
    let response = await axios.post('demo/auto_sc_login',formData);
    if (response.status === 200) {
        return response.data;
    }else{
        throw new Error(response.statusText)
    }
})

const IdiqApiSlice = createSlice({
    name:'idiq-api',
    initialState,
    reducers:{
        blankCreateUser:(state)=>{
            state.create_user = {};
        },
        blankCreateUserMoreInfo:(state)=>{
            state.create_user = {};
        },
        blankSubmitAnswer:(state)=>{
            state.submitAnswer = {};
        },
        blankCreditCardDetail:(state)=>{
            state.setCardDetail = {};
        },
        blankVerifyAnswers:(state)=>{
            state.verifyAnswers = {};
        }
    },
    extraReducers:(builder) => {
        builder.addCase(createUser.fulfilled,(state,action)=>{
            state.create_user = action.payload
        })
        builder.addCase(createMoreUserInfo.fulfilled,(state,action)=>{
            state.create_more_user_info = action.payload
        })
        builder.addCase(fetchQuestions.fulfilled,(state,action)=>{
            state.questions = action.payload
        })
        builder.addCase(submitQuestionAnswer.fulfilled,(state,action)=>{
            state.submitAnswer = action.payload
        })
        builder.addCase(validateCreditCard.fulfilled,(state,action)=>{
            state.validateCard = action.payload
        })
        builder.addCase(creditCardDetail.fulfilled,(state,action)=>{
            state.setCardDetail = action.payload
        })
        builder.addCase(completeEnrollment.fulfilled,(state,action)=>{
            state.completeEnrollmentData = action.payload
        })
        builder.addCase(autoScLogin.fulfilled,(state,action)=>{
            state.autoScLoginRes = action.payload
        })
        builder.addCase(verifyAnswers.fulfilled, (state, action) => {
          state.verifyAnswer = action.payload;
        });
    }
});

export const {blankCreateUser} = IdiqApiSlice.actions;

export default IdiqApiSlice.reducer;
